// Author YuJiaBei
// Date 2020-08-07 16:27:20

class EmArchLaborCostStand {
constructor({
        id = null,
        typeOfWork = '',
        hourly = '',
        typeLevel = '',
        remark = ''}
= {}) {
    this.id = id;
    this.typeOfWork = typeOfWork;
    this.hourly = hourly;
    this.typeLevel = typeLevel;
    this.remark = remark;
}
}

function newEntity() {
return new EmArchLaborCostStand();
}

function gridFields() {
return Object.freeze([
        {
        key: 'typeOfWork',
        label: 'label.em.archive.emArchLaborCostStand.grid.typeOfWork',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'hourly',
        label: 'label.em.archive.emArchLaborCostStand.grid.hourly',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'typeLevel',
        label: 'label.em.archive.emArchLaborCostStand.grid.typeLevel',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchLaborCostStand.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    typeOfWorkFilter : "",
    hourlyGeFilter : "",
    hourlyLeFilter : "",
    typeLevelFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'typeOfWorkFilter',
        label: 'label.em.archive.emArchLaborCostStand.filter.typeOfWork',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'hourlyGeFilter',
        label: 'label.em.archive.emArchLaborCostStand.filter.hourlyGe',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'hourlyLeFilter',
        label: 'label.em.archive.emArchLaborCostStand.filter.hourlyLe',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'typeLevelFilter',
        label: 'label.em.archive.emArchLaborCostStand.filter.typeLevel',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'typeOfWork',
        label: 'label.em.archive.emArchLaborCostStand.entity.typeOfWork',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'hourly',
        label: 'label.em.archive.emArchLaborCostStand.entity.hourly',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'typeLevel',
        label: 'label.em.archive.emArchLaborCostStand.entity.typeLevel',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchLaborCostStand.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmArchLaborCostStand, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
